function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.6 12h-1.9l-3.1-5.4V12h-1.3V4.9h1.9l3.1 5.3V5h1.3V12ZM80 8.4c0 1.2-.3 2.1-.9 2.7-.6.7-1.4 1-2.5 1-1 0-2-.3-2.5-1-.6-.6-.9-1.5-.9-2.7 0-1.2.3-2 .9-2.7.6-.6 1.4-1 2.5-1s2 .4 2.5 1c.6.6.9 1.5.9 2.7Zm-5.2 0c0 .8.1 1.4.4 1.8.3.4.8.6 1.4.6 1.2 0 1.8-.8 1.8-2.4 0-1.6-.6-2.4-1.8-2.4-.6 0-1 .2-1.3.6a3 3 0 0 0-.5 1.8ZM85.5 5H87L84.6 12h-1.7l-2.4-7.1H82L83.4 9a15 15 0 0 1 .3 1.6l.4-1.6L85.5 5Zm2.4 7.1V4.9h1.5V12h-1.5ZM97 8.4c0 1.1-.3 2-1 2.7-.7.6-1.6.9-2.9.9h-2V4.9h2.2c1.2 0 2.1.3 2.8.9.6.6 1 1.5 1 2.6Zm-1.6 0c0-1.5-.6-2.3-2-2.3h-.8v4.7h.7c1.4 0 2.1-.8 2.1-2.4ZM103 12l-.5-1.7h-2.7l-.5 1.7h-1.6l2.5-7.2h1.9l2.5 7.2H103Zm-1-3a1352.1 1352.1 0 0 1-.8-3 97 97 0 0 1-1 3h1.9Zm9.4-.6c0 1.1-.3 2-1 2.7-.6.6-1.6.9-2.9.9h-2V4.9h2.2c1.2 0 2.1.3 2.8.9.6.6 1 1.5 1 2.6Zm-1.5 0c0-1.5-.7-2.3-2-2.3h-.9v4.7h.7c1.4 0 2.2-.8 2.2-2.4ZM117 12H113V4.9h4.1V6h-2.6v1.6h2.4v1.2h-2.4v1.8h2.6V12Z",
  fill: "#07B07D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m46.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3L45.6 3a.4.4 0 0 1 .8 0",
  fill: "#07B07D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m46.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3L45.6 3a.4.4 0 0 1 .8 0",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m8.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5L2.8 7.2a.4.4 0 0 1 .2-.8L6 6l.3-.3L7.6 3a.4.4 0 0 1 .8 0",
  fill: "#07B07D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m8.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5L2.8 7.2a.4.4 0 0 1 .2-.8L6 6l.3-.3L7.6 3a.4.4 0 0 1 .8 0",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m27.3 4.2 1 2.1.2.2 2.2.3a.3.3 0 0 1 .2.6L29.3 9l-.1.3.4 2.3a.3.3 0 0 1-.5.4l-2-1.1H27l-2 1a.3.3 0 0 1-.5-.3l.4-2.3V9L23 7.4a.3.3 0 0 1 .2-.6l2.2-.3.2-.2 1-2.1a.3.3 0 0 1 .6 0",
  fill: "#07B07D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m27.3 4.2 1 2.1.2.2 2.2.3a.3.3 0 0 1 .2.6L29.3 9l-.1.3.4 2.3a.3.3 0 0 1-.5.4l-2-1.1H27l-2 1a.3.3 0 0 1-.5-.3l.4-2.3V9L23 7.4a.3.3 0 0 1 .2-.6l2.2-.3.2-.2 1-2.1a.3.3 0 0 1 .6 0",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m136.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3 1.3-2.8a.4.4 0 0 1 .8 0",
  fill: "#07B07D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m136.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3 1.3-2.8a.4.4 0 0 1 .8 0",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m174.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3 1.3-2.8a.4.4 0 0 1 .8 0",
  fill: "#07B07D"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m174.4 3 1.3 2.7c0 .2.2.3.3.3l3 .4a.4.4 0 0 1 .2.8l-2.1 2.2-.2.3.5 3.1a.4.4 0 0 1-.5.5l-2.7-1.5h-.4l-2.6 1.5a.4.4 0 0 1-.7-.5l.6-3c0-.2 0-.4-.2-.5l-2.1-2.1a.4.4 0 0 1 .2-.8l3-.4.3-.3 1.3-2.8a.4.4 0 0 1 .8 0",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m155.3 4.2 1 2.1.2.2 2.2.3a.3.3 0 0 1 .2.6L157.3 9l-.1.3.4 2.3a.3.3 0 0 1-.5.4l-2-1.1h-.2l-2 1a.3.3 0 0 1-.5-.3l.4-2.3V9L151 7.4a.3.3 0 0 1 .2-.6l2.2-.3.2-.2 1-2.1a.3.3 0 0 1 .6 0",
  fill: "#07B07D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m155.3 4.2 1 2.1.2.2 2.2.3a.3.3 0 0 1 .2.6L157.3 9l-.1.3.4 2.3a.3.3 0 0 1-.5.4l-2-1.1h-.2l-2 1a.3.3 0 0 1-.5-.3l.4-2.3V9L151 7.4a.3.3 0 0 1 .2-.6l2.2-.3.2-.2 1-2.1a.3.3 0 0 1 .6 0",
  fill: "#fff"
});

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 182,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 2,
    width: 12,
    height: 12
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _ref6), _ref7, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 4,
    width: 8,
    height: 9
  }, _ref8), _ref9, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 2,
    width: 12,
    height: 12
  }, _ref10), _ref11, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 2,
    width: 12,
    height: 12
  }, _ref12), _ref13, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 4,
    width: 8,
    height: 9
  }, _ref14));
}

var ForwardRef = React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.b9bd651d.svg";
export { ForwardRef as ReactComponent };